import React from 'react';

import {
	//Avatar,
	Box,
	Button,
	//IconButton,
	TextField,
	Typography
}
from '@mui/material';

import AddBlockIcon from 'icons/drawable/btn_add_block.svg';

import Block from './Block';
import BlockFactory from './BlockFactory';

import ColorPallet from './ColorPallet';
import ContentAclEdit from './ContentAclEdit';

import TextBlockEditView from './TextBlockEditView';
import ImageBlockEditView from './ImageBlockEditView';
import YoutubeBlockEditView from './YoutubeBlockEditView';
import VideoBlockEditView from './VideoBlockEditView';
import PDFBlockEditView from './PDFBlockEditView';
import BlockDivider from './BlockDivider';

import SelectBlockTypeModal from './SelectBlockTypeModal';

function BlockListEditView({
	isTemplate,
	backgroundColor,
	acl,
	blocks,
	onBackgroundChange,
	onAclChange,
	onBlockAdd,
	onBlockDelete,
	onBlockUpdate
}) {

	console.log("BlockListEditView()");

	const [contentOptionMode,setContentOptionMode] = React.useState("");

	const [contentBackground,setContentBackground] = React.useState(backgroundColor);
	const [contentAcl,setContentAcl] = React.useState(acl);

	const [selectBlockTypeOpen,setSelectBlockTypeOpen] = React.useState(false);

	function handleContentBackgroundChange(cv) {
		setContentBackground(cv);
		if (onBackgroundChange) {
			onBackgroundChange(cv);
		}
	}

	function handleContentAclChange(cv) {
		setContentAcl(cv);
		if (onAclChange) {
			onAclChange(cv);
		}
	}

	function handleAddBlock() {
		if (blocks.length >= 26) {		// 26 = the number of capital letters ('A' - 'Z')
			alert("더이상 블록을 추가할 수 없습니다");
			return;
		}

		global.extAppInterface.notifyEvent("NEW_BLOCK_ENTER");
		setSelectBlockTypeOpen(true);
	}

	function getNewBlockName(blockType) {
		//const NAME_PREFIX = BlockFactory.getDisplayBlockTypeName(blockType);
		const NAME_PREFIX = blockType + '-';

		let highest = 0;

		for (let i = 0; i < blocks.length; i++) {
			if (blocks[i].type === blockType) {
				let seqNum = Number(blocks[i].name.substring(NAME_PREFIX.length));
				if (seqNum > highest) {
					highest = seqNum;
				}
			}
		}

		return NAME_PREFIX + (highest + 1);
	}

	function handleBlockTypeSelect(blockType) {
		if (blockType) {
			let blockName = getNewBlockName(blockType);
			let newBlock = BlockFactory.createEmpty(blockType, blockName);

			if (onBlockAdd) {
				onBlockAdd(newBlock);
			}
		}
		setSelectBlockTypeOpen(false);
		global.extAppInterface.notifyEvent("NEW_BLOCK_EXIT");
	}

	function handleBlockUpdate(block) {
		if (onBlockUpdate) {
			onBlockUpdate(block);
		}
	}

	function handleBlockDelete(block) {
		if (onBlockDelete) {
			onBlockDelete(block);
		}
	}

	function getBlockEditView(blockType, block, idx) {
		const iconColors = [
			'orange',
			'purple',
		];

		let iconChar = String.fromCharCode('A'.charCodeAt(0) + idx);
		let iconColor = iconColors[idx % iconColors.length];

		if (blockType === Block.TYPE_TEXT) {
			return (
				<>
				<TextBlockEditView
					key={block.name}
					idx={idx}
					iconChar={iconChar}
					iconColor={iconColor}
					block={block}
					onUpdate={handleBlockUpdate}
					onDelete={handleBlockDelete}
				/>
				<BlockDivider
					key={'divider-'+block.name}
					marginTop={`${30/360 * 100}vw`}
				/>
				</>
			);
		}
		else if (blockType === Block.TYPE_IMAGE) {
			return (
				<>
				<ImageBlockEditView
					key={block.name}
					idx={idx}
					iconChar={iconChar}
					iconColor={iconColor}
					block={block}
					onUpdate={handleBlockUpdate}
					onDelete={handleBlockDelete}
				/>
				<BlockDivider
					key={'divider-'+block.name}
					marginTop={`${30/360 * 100}vw`}
				/>
				</>
			);
		}
		else if (blockType === Block.TYPE_YOUTUBE) {
			return (
				<>
				<YoutubeBlockEditView
					key={block.name}
					idx={idx}
					iconChar={iconChar}
					iconColor={iconColor}
					block={block}
					onUpdate={handleBlockUpdate}
					onDelete={handleBlockDelete}
				/>
				<BlockDivider
					key={'divider-'+block.name}
					marginTop={`${30/360 * 100}vw`}
				/>
				</>
			);
		}
		else if (blockType === Block.TYPE_VIDEO) {
			return (
				<>
				<VideoBlockEditView
					key={block.name}
					idx={idx}
					iconChar={iconChar}
					iconColor={iconColor}
					block={block}
					onUpdate={handleBlockUpdate}
					onDelete={handleBlockDelete}
				/>
				<BlockDivider
					key={'divider-'+block.name}
					marginTop={`${30/360 * 100}vw`}
				/>
				</>
			);
		}
		else if (blockType === Block.TYPE_PDF) {
			return (
				<>
				<PDFBlockEditView
					key={block.name}
					idx={idx}
					iconChar={iconChar}
					iconColor={iconColor}
					block={block}
					onUpdate={handleBlockUpdate}
					onDelete={handleBlockDelete}
				/>
				<BlockDivider
					key={'divider-'+block.name}
					marginTop={`${30/360 * 100}vw`}
				/>
				</>
			);
		}
	}

	function getBlockEditViews() {
		let blockEditViews = [];

		for (let i = 0; i < blocks.length; i++) {
			let blockEditView = getBlockEditView(blocks[i].type, blocks[i], i);
			if (blockEditView) blockEditViews.push(blockEditView);
		}
		return blockEditViews;
	}

	function getFooter() {
		return (
			<Box
				key='footer'
				display='flex'
				flexDirection='column'
				justifyContent='center'
				alignItems='center'
				sx={{
					width:'100%',
					marginTop:`${20/360 * 100}vw`,
				}}
			>
				<Box
					display='flex'
					flexDirection='row'
					justifyContent='center'
					alignItems='center'
					sx={{
						width:'100%',
						height:`${30/360 * 100}vw`,
					}}
				>
					<Button
						variant="text"
						startIcon={
							<img
								src={AddBlockIcon}
								style={{
									width:`${30/360 * 100}vw`,
									height:`${30/360 * 100}vw`,
									marginRight:`${10/360 * 100}vw`
								}}
								alt='add block icon'
							/>
						}
						sx={{
							color: '#6cadff',
							width: `${100/360 * 100}vw`,
							height: `${30/360 * 100}vw`,
						}}
						onClick={e => handleAddBlock()}
					>
						<Typography
							fontFamily='노토산스 Bold'
							fontSize={`${14/360 * 100}vw`}
							color='#6cadff'
							sx={{margin:'-10px'}}
						>
							블럭 추가
						</Typography>
					</Button>
				</Box>
			</Box>
		);
	}

	function getContentConfigTitle() {
		return (
			<Box
				display="flex"
				flexDirection="row"
				justifyContent="flex-start"
				alignItems="center"
				sx={{
					marginTop: `${30/360 * 100}vw`,
				}}
			>
				<img
					src="icons/drawable-xxhdpi/상세설정_아이콘.png"
					style={{
						width:`${20/360 * 100}vw`,
						height:`${20/360 * 100}vw`,
						marginRight:`${10/360 * 100}vw`
					}}
					alt='content config icon'
				/>
				<Typography
					sx={{
						fontFamily: '노토산스 Bold',
						fontSize: `${16/360 * 100}vw`,
						color: '#171717',
					}}
				>
					상세 설정
				</Typography>
			</Box>
		);
	}

	function getContentAclConfig() {
		console.log("getContentAclConfig: isTemplate = " + isTemplate);

		if (isTemplate) {
			return null;
		}

		return (
			<ContentAclEdit
				key='content-acl-edit'
				curAcl={contentAcl}
				onUpdate={handleContentAclChange}
			/>
		);
	}

	function getContentConfigButtons() {
		const btnFontSize = 14;
		const btnTextMargin = -10;

		return (
			<Box
				display='flex'
				flexDirection='row'
				justifyContent='flex-start'
				alignItems='center'
				sx={{
					width:'100%',
					marginTop: `${20/360 * 100}vw`,
				}}
			>
				<Button
					variant="outlined"
					sx={{
						//color: contentOptionMode === 'backgroundColor' ? 'white' : "#6cadff",
						bgcolor: contentOptionMode === 'backgroundColor' ? '#336cadff' : 'white',
						border: `${1/360 * 100}vw solid #6cadff`,
						borderRadius: `${15/360 * 100}vw`,
						width: `${120/360 * 100}vw`,
						height: `${30/360 * 100}vw`,
					}}
					onClick={e => setContentOptionMode(contentOptionMode === 'backgroundColor' ? undefined : 'backgroundColor')}
				>
					<Typography
						fontFamily='노토산스 Bold'
						fontSize={`${btnFontSize/360 * 100}vw`}
						color={contentOptionMode === 'backgroundColor' ? 'white' : "#6cadff"}
						sx={{margin:`${btnTextMargin}px`}}
					>
						전체 배경 색상
					</Typography>
				</Button>
			</Box>
		);
	}

	function getOptionalSetting() {
		if (contentOptionMode === 'backgroundColor') {
			return (
				<ColorPallet
					key='content-background-pallet'
					curColorValue={contentBackground}
					onUpdate={handleContentBackgroundChange}
				/>
			);
		}
	}

	function getContentConfig() {
		return (
			<>
			<BlockDivider
				key='divider-header1'
				marginTop={`${20/360 * 100}vw`}
			/>
			<Box
				display="flex"
				flexDirection="column"
				justifyContent="flex-start"
				alignItems="flex-start"
				sx={{
					width: `${320/360 * 100}vw`,
					marginLeft: `${20/360 * 100}vw`,
					marginRight: `${20/360 * 100}vw`,
				}}
			>
				{getContentConfigTitle()}
				{getContentAclConfig()}
				{getContentConfigButtons()}
				{getOptionalSetting()}
			</Box>
			<BlockDivider
				key='divider-header2'
				marginTop={`${20/360 * 100}vw`}
			/>
			</>
		);
/*
		return (
			<>
			<Box
				key='header'
				display='flex'
				flexDirection='column'
				justifyContent='flex-start'
				alignItems='flex-start'
				sx={{
					left: `${20/360 * 100}vw`,
					width: `${320/360 * 100}vw`,
					height: `${70/360 * 100}vw`,
					marginTop: `${30/360 * 100}vw`,
				}}
			>
				<Typography
					sx={{
						fontFamily: '노토산스 Bold',
						fontSize: `${16/360 * 100}vw`,
						color: '#171717',
					}}
				>
					전체 콘텐츠 설정
				</Typography>
				<Button
					variant="outlined"
					sx={{
						color: "#6cadff",
						bgcolor: 'white',
						border: `${1/360 * 100}vw solid #6cadff`,
						borderRadius: `${15/360 * 100}vw`,
						width: `${120/360 * 100}vw`,
						height: `${30/360 * 100}vw`,
						marginTop: `${20/360 * 100}vw`,
					}}
					onClick={e => setContentOptionMode("backgroundColor")}
				>
					<Typography
						sx={{
							fontFamily: '노토산스 Bold',
							fontSize: `${14/360 * 100}vw`,
							color:'#6cadff'
						}}
					>
						전체 배경 색상
					</Typography>
				</Button>
			</Box>
			{
				contentOptionMode === "backgroundColor" &&
				<ColorPallet
					key='color-pallet'
					curColorValue={contentBackground}
					onUpdate={handleContentBackgroundChange}
				/>
			}
			{
				contentOptionMode === "acl" &&
				<ContentAclEdit
					key='content-acl-edit'
					curAcl={contentAcl}
					onUpdate={handleContentAclChange}
				/>
			}
			<BlockDivider key='divider-header'/>
			</>
		);
*/
	}

	return (
		<Box
			display="flex"
			flexDirection="column"
			justifyContent="center"
			alignItems="center"
			sx={{
				bgcolor: 'white',
				position:"relative"
			}}
		>
			{ getBlockEditViews() }
			{ getFooter() }
			{ getContentConfig() }
			<SelectBlockTypeModal
				key='select-block-type'
				isOpen={selectBlockTypeOpen}
				onSelect={handleBlockTypeSelect}
			/>
		</Box>
	);
}

export default BlockListEditView;
